import React, { useState } from "react";
import { UncontrolledCollapse } from "reactstrap";
import styled from "styled-components";

import minusIcon from "../../assets/minus.svg";
import plusIcon from "../../assets/plus.svg";
import { ContentBlock } from "../../components/shared/layout/Layout";
import BodyTitle from "../../components/shared/text/BodyTitle";
import Headline from "../../components/shared/text/Headline";
import { LargeBodyText } from "../../components/shared/text/Text";
import { faqList } from "../../utils/faqList";

const ExpandableHeader = styled.button`
  border: none;
  display: flex;
  width: 100%;
  background: none;
  align-items: center;
`;
const ListContainer = styled.div`
  width: 100%;
`;
const ListItem = styled.div`
  ${ExpandableHeader.selector} {
    border-top: 0.5px solid #aaa;
    &:first-child {
      border-top: none;
    }
  }
`;

const ExpandableList = () => {
  const [items, setItems] = useState(faqList);
  return (
    <ListContainer className="p-0 p-md-5">
      {Object.values(items).map((item) => {
        const { id, title, isOpen, content } = item;
        return (
          <ListItem key={id}>
            <ExpandableHeader id={id} className="pt-4 pb-4">
              <img
                src={isOpen ? minusIcon : plusIcon}
                className="mr-4 mr-md-5"
                alt="Expansion icon"
              ></img>
              <BodyTitle className="text-left">{title}</BodyTitle>
            </ExpandableHeader>

            <UncontrolledCollapse
              className="pl-2"
              toggler={`#${id}`}
              onEntering={(param) => {
                setItems({
                  ...items,
                  [id]: {
                    ...item,
                    isOpen: true,
                  },
                });
              }}
              onExiting={() => {
                setItems({
                  ...items,
                  [id]: {
                    ...item,
                    isOpen: false,
                  },
                });
              }}
            >
              <LargeBodyText className="ml-4 pl-4 pl-md-5 pb-5 pr-5">
                {content}
              </LargeBodyText>
            </UncontrolledCollapse>
          </ListItem>
        );
      })}
    </ListContainer>
  );
};

const Faq = (props) => {
  return (
    <ContentBlock
      className="d-flex flex-column align-items-center p-4 p-md-5"
      {...props}
    >
      <Headline className="col-5 text-center">FAQ</Headline>
      <ExpandableList />
    </ContentBlock>
  );
};

export default Faq;
